// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"9778728c","312":"764d9376","375":"25e92088","484":"2de29ef3","551":"8e72c00b","800":"1f6e0d87","869":"b8a2f558","974":"7d9c2e9a"}[chunkId] + ".chunk.js";
};